<template>
  <v-main>
    <v-container v-if="$vuetify.breakpoint.smAndDown">
      <v-img
        src="@/assets/img/mobileAuthIcons/mobileBackground.svg"
        style="
          top: -10px;
          right: 0;
          position: absolute;
          width: 100%;
          heigth: 100%;
          object-fit: contain;
        "
      />
    </v-container>
    <v-container>
      <VRow class="align-center mt-10 mb-5">
        <div>
          <VIcon class="mx-5" large>mdi-store</VIcon>
        </div>
        <div v-if="!socials">
          <h2>{{ "add_business_fourth_step_title" | localize }}</h2>
        </div>
        <div v-else>
          <h2>Profile of Social Organization</h2>
        </div>
        <div
          class="mx-auto mx-sm-0 ml-sm-auto mt-sm-0 mt-3"
          v-if="!socials && tab == 'info'"
        >
          <v-btn outlined color="#72AFE7" class="pa-5" @click="startTour()">
            <VIcon class="mr-2 mt-1">mdi-message-question</VIcon>
            <h3>{{ "button-need-help" | localize }}</h3>
          </v-btn>
        </div>
      </VRow>
      <VRow>
        <div
          class="justify-center align-center my-7 col-12 mb-15"
          :class="{
            'mt-0': tab != 'info',
            'mt-15': tab == 'info',
          }"
        >
          <v-card
            :class="{
              'mt-0 pt-0 mb-5': tab == 'location',
              'mt-0 pa-sm-15 pa-5 pt-0': tab != 'location' && tab != 'info',
              'mt-15 pa-sm-15 pa-5 pt-15': tab == 'info',
            }"
          >
            <VRow
              :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
              v-if="!imgDataUrl && tab == 'info'"
            >
              <v-fab-transition>
                <v-btn
                  elevation="1"
                  class="img-btn"
                  :class="{
                    mobile: $vuetify.breakpoint.smAndDown,
                    'ml-15':
                      tab == 'location' && !$vuetify.breakpoint.smAndDown,
                  }"
                  tile
                  absolute
                  top
                  :style="styleImage ? 'border: 1px solid red !important' : ''"
                  fab
                  @click="toggleShow"
                >
                  <div
                    v-if="$vuetify.breakpoint.smAndDown"
                    style="
                      right: 0px;
                      bottom: -93px;
                      position: absolute;
                      width: 52px;
                    "
                  >
                    <v-img src="@/assets/businesses/plus-logo.svg" />
                  </div>
                  <div class="align-center">
                    <div v-if="!$vuetify.breakpoint.smAndDown">
                      <VIcon color="#72AFE7" large>mdi-camera</VIcon>
                    </div>
                    <div class="text-sm mt-3">
                      <span>{{
                        "add_business_second_step_logo" | localize
                      }}</span>
                    </div>
                  </div>
                </v-btn>
              </v-fab-transition>
            </VRow>
            <VRow
              :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
              v-if="imgDataUrl && tab == 'info'"
            >
              <v-fab-transition>
                <v-btn
                  elevation="1"
                  class="img-btn"
                  :class="{ mobile: $vuetify.breakpoint.smAndDown }"
                  tile
                  absolute
                  top
                  fab
                  @click="toggleShow"
                  :style="'background-image: var(--bg-img)'"
                >
                  <img
                    class="ins-img"
                    :class="{ mobile: $vuetify.breakpoint.smAndDown }"
                    :src="imgDataUrl"
                  />
                </v-btn>
              </v-fab-transition>
            </VRow>
            <my-upload
              field="img"
              ref="upload"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              @src-file-set="srcFileSet"
              v-model="show"
              :width="512"
              :height="512"
              :params="params"
              :lang-type="loggedUser.locale === 'es' ? 'es-MX' : 'en'"
              noCircle
              :headers="headers"
              img-format="png"
            ></my-upload>
            <v-tabs vertical v-model="tab" hide-slider>
              <v-tab
                v-show="false"
                style="display: none !important"
                href="#info"
              >
              </v-tab>
              <v-tab style="display: none !important" href="#openHours">
              </v-tab>
              <v-tab style="display: none !important" href="#location"> </v-tab>
              <v-tab style="display: none !important" href="#payment"> </v-tab>
              <v-tabs-items v-model="tab" touchless>
                <v-tab-item value="info">
                  <add-business-info
                    @addedInfo="addedInfo"
                    @toggleShow="show = !show"
                    @toFirstStep="toFirstStep"
                    ref="info"
                  />
                </v-tab-item>
                <v-tab-item value="openHours">
                  <add-business-open-hours
                    @previous="tab = 'info'"
                    ref="openHours"
                    @toLastStep="lastStep"
                    @addedOpenHours="addedOpenHours"
                  />
                </v-tab-item>
                <v-tab-item value="location">
                  <add-business-location
                    ref="location"
                    @previous="tab = 'openHours'"
                    @toLastStep="lastStepLocation"
                    @addedLocation="addedLocation"
                  />
                </v-tab-item>
                <v-tab-item value="payment" v-if="!socials">
                  <add-business-payment
                    ref="payment"
                    @previous="tab = 'location'"
                    @toLastStep="lastStepPayment"
                    @addedPayment="createBusiness"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card>
        </div>
      </VRow>
    </v-container>
  </v-main>
</template>


<script>
import AddBusinessInfo from "@/components/Businesses/add-business-info.vue";
import AddBusinessOpenHours from "@/components/Businesses/add-business-open-hours.vue";
import AddBusinessLocation from "@/components/Businesses/add-business-location.vue";
import BusinessService from "@/requests/Business/BusinessService";
import SocialService from "@/requests/Socials/SocialService";
import AddBusinessPayment from "@/components/Businesses/add-business-payment.vue";
import myUpload from "vue-image-crop-upload/upload-2.vue";
import requestFormData from "@/requests/requestFormData";
import { mapGetters } from "vuex";
export default {
  components: {
    AddBusinessInfo,
    AddBusinessOpenHours,
    AddBusinessLocation,
    AddBusinessPayment,
    "my-upload": myUpload,
  },
  data: () => ({
    tab: "info",
    show: false,
    styleImage: false,
    params: {
      token: "123456798",
      name: "avatar",
    },
    headers: {
      smail: "*_~",
    },
    imgDataUrl: "", // the datebase64 url of created image
    business: {},
    fileName: "",
    tour: false,
    socials: false,
    createLoading: false,
  }),
  computed: {
    ...mapGetters(["loggedUser"]),
  },
  destroyed() {
    localStorage.removeItem("tutorialStep");
    this.$refs.info.resetSteps();
    this.$refs.openHours.resetSteps();
    this.$refs.location.resetSteps();
    this.$refs.payment.resetSteps();
  },
  mounted() {
    if (process.env.VUE_APP_TYPE === "Social") {
      this.socials = true;
    } else {
      localStorage.removeItem("tutorialStep");
    }
  },
  watch: {
    tab: {
      handler() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
  },
  methods: {
    addedInfo(info, tour) {
      if (this.imgDataUrl == "") {
        console.log(this.styleImage);
        this.styleImage = true;
      } else {
        console.log(tour);
        let that = this;
        this.business = info;
        console.log(this.business);
        this.tab = "openHours";
        if (tour) {
          setTimeout(function () {
            that.$refs.openHours.nextTutorial();
          }, 700);
        }
      }
    },
    addedOpenHours(working_days, working_hours, tour) {
      let that = this;
      this.tab = "location";
      this.business["working_days"] = working_days;
      this.business["working_hours"] = working_hours;
      if (tour) {
        setTimeout(function () {
          that.$refs.location.nextTutorial();
        }, 700);
      }
    },
    addedLocation(lat, lng, address, tour) {
      let that = this;
      if (!this.socials) {
        this.tab = "payment";
      }
      this.business["geo_lat"] = lat;
      this.business["geo_lng"] = lng;
      this.business["address"] = address;
      if (this.socials) {
        console.log(this.business);
        this.createSocial();
      }
      if (tour && !this.socials) {
        setTimeout(function () {
          that.$refs.payment.nextTutorial();
        }, 600);
      }
    },
    async createSocial() {
      let data = {
        type: parseInt(this.business.type),
        name: this.business.name,
        is_public: this.business.label.value,
        description: this.business.description,
        email: this.business.email,
        phone_code: this.business.phoneCode.replace(/\D+/g, ""),
        phone_number: this.business.phoneNumber,
        website: this.business.website || "",
        address: this.business.address,
        geo_lat: this.business.geo_lat,
        geo_lon: this.business.geo_lng,
        neighbourhood: parseInt(this.business.neighbourhood),
        internet: this.business.internetAccess,
        size: parseInt(this.business.employees.id),
        logo: this.imgDataUrl || "",
        working_days: this.business.working_days,
        working_hours: this.business.working_hours,
      };
      let form = requestFormData.jsonToFormData(data);
      await SocialService.createSocial(form);
      this.$router.push({ name: "socials" });
    },
    async createBusiness(products, hoozies) {
      console.log(products);
      this.business["products"] = products;
      this.business["hoozies"] = hoozies;
      console.log(
        "d",
        this.business.working_days,
        "h",
        this.business.working_hours
      );
      let category_array = [];
      if (this.business.subcategories) {
        this.business.subcategories = this.business.subcategories.map((i) =>
          Number(i)
        );
        for (let i = 0; i < this.business.subcategories.length; i++) {
          category_array.push({
            category_id: parseInt(this.business.category),
            subcategory_id: this.business.subcategories[i],
          });
        }
      } else {
        category_array.push({
          category_id: parseInt(this.business.category),
        });
      }

      let data = {
        //type: parseInt(this.business.type),
        category: category_array,
        shop_name: this.business.name,
        shop_description: this.business.description,
        shop_email: this.business.email,
        phone_code: this.business.phoneCode.replace(/\D+/g, ""),
        phone_number: this.business.phoneNumber.replace(/\D+/g, ""),
        shop_website: this.business.website || "",
        address: this.business.address,
        geo_lat: this.business.geo_lat,
        geo_lon: this.business.geo_lng,
        neighbourhood: this.business.neighbourhood,
        device_access:this.business.cashiersDevice,
        internet: this.business.internetAccess,
        size: this.business.employees,
        canaco_id: this.business.chambers || "",
        shop_logo: this.imgDataUrl || "",
        discount_amount_min: this.business.hoozies,
        discount_amount_max: this.business.hoozies,
        discount_type: this.business.products,
        working_days: this.business.working_days,
        working_hours: this.business.working_hours,
        referral_id: this.business.ref,
        city_id: "1",
        municipality: this.business.municipality,
      };
      let form = requestFormData.jsonToFormData(data);
      await BusinessService.createBusiness(form).then((res) => {
        localStorage.startPromotion = "true";
        this.$router.push(
          `/business/edit/${res.result.uid}/products?new_business=${this.$route.query.new_business}`
        );
      });
    },
    lastStep() {
      let that = this;
      this.tab = "info";
      setTimeout(function () {
        that.$refs.info.getLast();
      }, 600);
    },
    lastStepLocation() {
      this.tab = "openHours";
      let that = this;
      setTimeout(function () {
        that.$refs.openHours.getLast();
      }, 600);
    },
    lastStepPayment() {
      this.tab = "location";
      let that = this;
      setTimeout(function () {
        that.$refs.location.getLast();
      }, 500);
    },
    toFirstStep() {
      this.$refs.upload.setStep(1);
    },
    startTour() {
      if (localStorage.tutorialStep) {
        let tutorialStep = localStorage.tutorialStep;
        if (
          tutorialStep == "openHours" ||
          tutorialStep == "openHours2" ||
          tutorialStep == "checkDay" ||
          tutorialStep == "from" ||
          tutorialStep == "to" ||
          tutorialStep == "nextOpen"
        ) {
          this.tab = "openHours";
          this.$refs.openHours.nextTutorial();
        } else if (tutorialStep == "map" || tutorialStep == "nextLocation") {
          this.tab = "location";
          this.$refs.location.nextTutorial();
        } else if (
          tutorialStep == "payment" ||
          tutorialStep == "discount" ||
          tutorialStep == "hoozies" ||
          tutorialStep == "nextPayment"
        ) {
          this.tab = "payment";
          this.$refs.payment.nextTutorial();
        } else {
          this.tab = "info";
          this.$refs.info.startTutorial();
        }
      } else {
        this.$refs.info.startTutorial();
      }
    },
    toggleShow() {
      this.show = !this.show;
      if (this.imgDataUrl || this.fileName) {
        this.$refs.info.onUploadImage();
      } else {
        this.$refs.info.onUploadClick(this.show);
      }
    },
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
      this.$refs.info.onSaveImage();
      console.log("field: " + field);
    },
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    srcFileSet(fileName, fileType, fileSize) {
      console.log(fileName, fileType, fileSize);
      this.fileName = fileName;
      this.$refs.info.onUploadImage();
    },
  },
};
</script>

<style scoped lang="scss">
.img-btn {
  border-radius: 20px;
  width: 175px;
  height: 175px;
  top: -120px !important;
  color: #72afe7;
  border: 1px solid #72afe7 !important;
  text-transform: none;
  background-color: #fff;
  &.mobile {
    border-radius: 50%;
    border: unset !important;
    background-color: #d9d9d9;
    color: rgb(85, 85, 85);
    font-weight: 700;
  }
}
.v-slide-group {
  display: none !important;
}
.ins-img {
  border-radius: 20px;
  width: 175px;
  height: 175px;
  top: -120px !important;
  color: #72afe7;
  border: 1px solid #72afe7 !important;
  text-transform: none;
  &.mobile {
    border-radius: 50%;
    border: unset !important;
    background-color: #d9d9d9;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
}
</style>